export const data = [
  {
    id: 715594,
    value: {
      vegetarian: true,
      vegan: true,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: true,
      cheap: false,
      veryPopular: true,
      sustainable: false,
      weightWatcherSmartPoints: 19,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1669,
      spoonacularScore: 99.0,
      healthScore: 78.0,
      creditsText: "Jen West",
      sourceName: "Pink When",
      pricePerServing: 83.23,
      extendedIngredients: [
        {
          id: 2044,
          aisle: "Produce",
          image: "fresh-basil.jpg",
          consistency: "solid",
          name: "basil",
          nameClean: "fresh basil",
          original: "1/4 cup basil",
          originalName: "basil",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "1 cup flour",
          originalName: "flour",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1022020,
          aisle: "Spices and Seasonings",
          image: "garlic-powder.png",
          consistency: "solid",
          name: "garlic powder",
          nameClean: "garlic powder",
          original: "1/4 garlic powder",
          originalName: "garlic powder",
          amount: 0.25,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 0.25,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 1062047,
          aisle: "Spices and Seasonings",
          image: "garlic-salt.jpg",
          consistency: "solid",
          name: "garlic salt",
          nameClean: "garlic salt",
          original: "garlic salt with parsley (to sprinkle)",
          originalName: "garlic salt with parsley (to sprinkle)",
          amount: 2.0,
          unit: "servings",
          meta: ["with parsley (to sprinkle)"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11352,
          aisle: "Produce",
          image: "potatoes-yukon-gold.png",
          consistency: "solid",
          name: "potatoes",
          nameClean: "potato",
          original: "4 sliced, fresh potatoes",
          originalName: "sliced, fresh potatoes",
          amount: 4.0,
          unit: "",
          meta: ["fresh", "sliced"],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 4513,
          aisle: null,
          image: null,
          consistency: null,
          name: "vegetable oil",
          nameClean: null,
          original: "vegetable oil",
          originalName: "vegetable oil",
          amount: 2.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
      ],
      id: 715594,
      title: "Homemade Garlic and Basil French Fries",
      readyInMinutes: 45,
      servings: 2,
      sourceUrl: "http://www.pinkwhen.com/homemade-french-fries/",
      image: "https://spoonacular.com/recipeImages/715594-556x370.jpg",
      imageType: "jpg",
      summary:
        'The recipe Homemade Garlic and Basil French Fries is ready <b>in roughly 45 minutes</b> and is definitely a super <b>vegan</b> option for lovers of American food. One serving contains <b>596 calories</b>, <b>18g of protein</b>, and <b>15g of fat</b>. For <b>83 cents per serving</b>, you get a side dish that serves 2. Several people made this recipe, and 1669 would say it hit the spot. If you have garlic salt, flour, garlic powder, and a few other ingredients on hand, you can make it. All things considered, we decided this recipe <b>deserves a spoonacular score of 100%</b>. This score is outstanding. Try <a href="https://spoonacular.com/recipes/homemade-french-fries-with-fresh-garlic-and-dill-494220">Homemade French Fries with Fresh Garlic and Dill</a>, <a href="https://spoonacular.com/recipes/roasted-garlic-french-fries-519898">Roasted Garlic French Fries</a>, and <a href="https://spoonacular.com/recipes/sweet-potato-fries-with-basil-salt-and-garlic-mayonnaise-120735">Sweet Potato Fries With Basil Salt and Garlic Mayonnaise</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["dairy free", "lacto ovo vegetarian", "vegan"],
      occasions: [],
      winePairing: {
        pairedWines: [],
        pairingText: "",
        productMatches: [],
      },
      instructions: null,
      analyzedInstructions: [],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/homemade-garlic-and-basil-french-fries-715594",
    },
  },
  {
    id: 715424,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: true,
      sustainable: false,
      weightWatcherSmartPoints: 8,
      gaps: "no",
      lowFodmap: false,
      preparationMinutes: 10,
      cookingMinutes: 120,
      aggregateLikes: 65477,
      spoonacularScore: 96.0,
      healthScore: 34.0,
      creditsText: "Jen West",
      sourceName: "Pink When",
      pricePerServing: 201.37,
      extendedIngredients: [
        {
          id: 10211821,
          aisle: "Produce",
          image: "bell-pepper-orange.png",
          consistency: "solid",
          name: "bell pepper",
          nameClean: "bell pepper",
          original: "1/4 cup bell pepper",
          originalName: "bell pepper",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 16034,
          aisle: "Canned and Jarred",
          image: "kidney-beans.jpg",
          consistency: "solid",
          name: "canned kidney beans",
          nameClean: "canned kidney beans",
          original: "1 (15 oz) can kidney beans",
          originalName: "kidney beans",
          amount: 15.0,
          unit: "oz",
          meta: ["canned"],
          measures: {
            us: {
              amount: 15.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 425.243,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 16044,
          aisle: "Canned and Jarred",
          image: "pinto-beans.jpg",
          consistency: "solid",
          name: "canned pinto beans",
          nameClean: "canned pinto beans",
          original: "1 (15 oz) can pinto beans",
          originalName: "pinto beans",
          amount: 15.0,
          unit: "oz",
          meta: ["canned"],
          measures: {
            us: {
              amount: 15.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 425.243,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 2031,
          aisle: "Spices and Seasonings",
          image: "chili-powder.jpg",
          consistency: "solid",
          name: "cayenne pepper",
          nameClean: "ground cayenne pepper",
          original: "1/4 tsp cayenne pepper",
          originalName: "cayenne pepper",
          amount: 0.25,
          unit: "tsp",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 2009,
          aisle: "Spices and Seasonings",
          image: "chili-powder.jpg",
          consistency: "solid",
          name: "chili powder",
          nameClean: "chili powder",
          original: "1/2 Tbsp chili powder",
          originalName: "chili powder",
          amount: 0.5,
          unit: "Tbsp",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 0.5,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 1002014,
          aisle: "Spices and Seasonings",
          image: "ground-cumin.jpg",
          consistency: "solid",
          name: "cumin",
          nameClean: "cumin",
          original: "1 1/2 tsp cumin",
          originalName: "cumin",
          amount: 1.5,
          unit: "tsp",
          meta: [],
          measures: {
            us: {
              amount: 1.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 1.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 23557,
          aisle: "Meat",
          image: "fresh-ground-beef.jpg",
          consistency: "solid",
          name: "lean ground beef",
          nameClean: "95 percent lean ground beef",
          original: "2 lbs lean ground beef",
          originalName: "lean ground beef",
          amount: 2.0,
          unit: "lbs",
          meta: ["lean"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "lb",
              unitLong: "pounds",
            },
            metric: {
              amount: 907.185,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "onions",
          nameClean: "onion",
          original: "1 1/2 cups chopped onions",
          originalName: "chopped onions",
          amount: 1.5,
          unit: "cups",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 1.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 354.882,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2027,
          aisle: "Produce;Spices and Seasonings",
          image: "oregano.jpg",
          consistency: "solid",
          name: "oregano",
          nameClean: "oregano",
          original: "1/2 tsp oregano",
          originalName: "oregano",
          amount: 0.5,
          unit: "tsp",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 1002030,
          aisle: "Spices and Seasonings",
          image: "pepper.jpg",
          consistency: "solid",
          name: "pepper",
          nameClean: "black pepper",
          original: "1 tsp group black pepper",
          originalName: "group black pepper",
          amount: 1.0,
          unit: "tsp",
          meta: ["black"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 11886,
          aisle: "Beverages",
          image: "tomato-juice.jpg",
          consistency: "liquid",
          name: "tomato juice",
          nameClean: "tomato juice",
          original: "1 (46 oz) can tomato juice",
          originalName: "tomato juice",
          amount: 46.0,
          unit: "oz",
          meta: ["canned"],
          measures: {
            us: {
              amount: 46.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 1.304,
              unitShort: "kilogram",
              unitLong: "kilograms",
            },
          },
        },
        {
          id: 11887,
          aisle: "Pasta and Rice",
          image: "tomato-paste.jpg",
          consistency: "solid",
          name: "tomato paste",
          nameClean: "tomato paste",
          original: "2 (6oz) cans tomato paste",
          originalName: "tomato paste",
          amount: 12.0,
          unit: "oz",
          meta: ["canned"],
          measures: {
            us: {
              amount: 12.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 340.194,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "1 cup water",
          originalName: "water",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "white sugar",
          nameClean: "sugar",
          original: "1/2 tsp white sugar",
          originalName: "white sugar",
          amount: 0.5,
          unit: "tsp",
          meta: ["white"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
      ],
      id: 715424,
      title: "The Best Chili",
      readyInMinutes: 130,
      servings: 8,
      sourceUrl: "http://www.pinkwhen.com/the-best-chili-recipe/",
      image: "https://spoonacular.com/recipeImages/715424-556x370.jpg",
      imageType: "jpg",
      summary:
        'The recipe The Best Chili is ready <b>in about 2 hours and 10 minutes</b> and is definitely a spectacular <b>gluten free and dairy free</b> option for lovers of American food. For <b>$2.01 per serving</b>, this recipe <b>covers 29%</b> of your daily requirements of vitamins and minerals. This recipe makes 8 servings with <b>323 calories</b>, <b>33g of protein</b>, and <b>7g of fat</b> each. This recipe from Pink When has 65475 fans. It works well as a rather cheap main course. It can be enjoyed any time, but it is especially good for <b>The Super Bowl</b>. A mixture of group pepper, oregano, tomato paste, and a handful of other ingredients are all it takes to make this recipe so flavorful. To use up the white sugar you could follow this main course with the <a href="https://spoonacular.com/recipes/whole-wheat-refined-sugar-free-sugar-cookies-557184">Whole Wheat Refined Sugar Free Sugar Cookies</a> as a dessert. All things considered, we decided this recipe <b>deserves a spoonacular score of 97%</b>. This score is outstanding. Try <a href="https://spoonacular.com/recipes/5th-annual-chili-contest-entry-2-jamaican-jerk-chili-+-weekly-menu-612833">5th Annual Chili Contest: Entry #2 – Jamaican Jerk Chili + Weekly Menu</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["gluten free", "dairy free"],
      occasions: ["super bowl"],
      winePairing: {
        pairedWines: [],
        pairingText: "",
        productMatches: [],
      },
      instructions:
        "<ol><li>Brown the lean ground beef in a deep skillet. Cook over medium heat until cooked all the way through, and then drain.</li><li>In a large pan over high heat add in all of your additional ingredients: cooked ground beef, tomato juice, kidney beans, pinto beans, water, tomato paste, chili powder, cumin, black pepper, oregano, sugar, cayenne pepper, bell pepper, and chopped onions.</li><li>Bring to a boil.</li><li>Once your large pot of chili has started to boil, lower the heat and simmer for 2 hours uncovered.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Brown the lean ground beef in a deep skillet. Cook over medium heat until cooked all the way through, and then drain.In a large pan over high heat add in all of your additional ingredients: cooked ground beef, tomato juice, kidney beans, pinto beans, water, tomato paste, chili powder, cumin, black pepper, oregano, sugar, cayenne pepper, bell pepper, and chopped onions.Bring to a boil.Once your large pot of chili has started to boil, lower the heat and simmer for 2 hours uncovered.",
              ingredients: [
                {
                  id: 23557,
                  name: "lean ground beef",
                  localizedName: "lean ground beef",
                  image: "fresh-ground-beef.jpg",
                },
                {
                  id: 2031,
                  name: "cayenne pepper",
                  localizedName: "cayenne pepper",
                  image: "chili-powder.jpg",
                },
                {
                  id: 1002030,
                  name: "black pepper",
                  localizedName: "black pepper",
                  image: "pepper.jpg",
                },
                {
                  id: 2009,
                  name: "chili powder",
                  localizedName: "chili powder",
                  image: "chili-powder.jpg",
                },
                {
                  id: 16033,
                  name: "kidney beans",
                  localizedName: "kidney beans",
                  image: "kidney-beans.jpg",
                },
                {
                  id: 11886,
                  name: "tomato juice",
                  localizedName: "tomato juice",
                  image: "tomato-juice.jpg",
                },
                {
                  id: 11887,
                  name: "tomato paste",
                  localizedName: "tomato paste",
                  image: "tomato-paste.jpg",
                },
                {
                  id: 10211821,
                  name: "bell pepper",
                  localizedName: "bell pepper",
                  image: "bell-pepper-orange.png",
                },
                {
                  id: 10023572,
                  name: "ground beef",
                  localizedName: "ground beef",
                  image: "fresh-ground-beef.jpg",
                },
                {
                  id: 16043,
                  name: "pinto beans",
                  localizedName: "pinto beans",
                  image: "pinto-beans.jpg",
                },
                {
                  id: 2027,
                  name: "oregano",
                  localizedName: "oregano",
                  image: "oregano.jpg",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
                {
                  id: 11819,
                  name: "chili pepper",
                  localizedName: "chili pepper",
                  image: "red-chili.jpg",
                },
                {
                  id: 1002014,
                  name: "cumin",
                  localizedName: "cumin",
                  image: "ground-cumin.jpg",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 120,
                unit: "minutes",
              },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/the-best-chili-715424",
    },
  },
  {
    id: 642540,
    value: {
      vegetarian: true,
      vegan: true,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 23,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 70,
      spoonacularScore: 94.0,
      healthScore: 41.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 190.12,
      extendedIngredients: [
        {
          id: 16058,
          aisle: "Canned and Jarred",
          image: "chickpeas.png",
          consistency: "solid",
          name: "canned garbanzo beans",
          nameClean: "canned chickpeas",
          original: "2 cans garbanzo beans (chickpeas), drained and rinsed",
          originalName: "garbanzo beans (chickpeas), drained and rinsed",
          amount: 2.0,
          unit: "cans",
          meta: ["drained and rinsed", "(chickpeas)"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cans",
              unitLong: "cans",
            },
            metric: {
              amount: 2.0,
              unitShort: "cans",
              unitLong: "cans",
            },
          },
        },
        {
          id: 2009,
          aisle: "Spices and Seasonings",
          image: "chili-powder.jpg",
          consistency: "solid",
          name: "chili powder",
          nameClean: "chili powder",
          original: "1 tablespoon chili powder",
          originalName: "chili powder",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 2012,
          aisle: "Spices and Seasonings",
          image: "ground-coriander.jpg",
          consistency: "solid",
          name: "coriander",
          nameClean: "dried cilantro",
          original: "1 tablespoon coriander",
          originalName: "coriander",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 1002014,
          aisle: "Spices and Seasonings",
          image: "ground-cumin.jpg",
          consistency: "solid",
          name: "cumin",
          nameClean: "cumin",
          original: "1 tablespoon cumin",
          originalName: "cumin",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 20081,
          aisle: "Baking",
          image: "flour.png",
          consistency: "solid",
          name: "flour",
          nameClean: "wheat flour",
          original: "4 tablespoons flour",
          originalName: "flour",
          amount: 4.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 4.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11297,
          aisle: "Produce;Spices and Seasonings",
          image: "parsley.jpg",
          consistency: "solid",
          name: "fresh parsley",
          nameClean: "parsley",
          original: "1 large handful parsley, chopped",
          originalName: "parsley, chopped",
          amount: 1.0,
          unit: "large handful",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "large handful",
              unitLong: "large handful",
            },
            metric: {
              amount: 1.0,
              unitShort: "large handful",
              unitLong: "large handful",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "2 cloves garlic, grated or finely chopped",
          originalName: "garlic, grated or finely chopped",
          amount: 2.0,
          unit: "cloves",
          meta: ["grated", "finely chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cloves",
              unitLong: "cloves",
            },
            metric: {
              amount: 2.0,
              unitShort: "cloves",
              unitLong: "cloves",
            },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "juice of lemon",
          nameClean: "lemon juice",
          original: "2 Zest and juice of lemons",
          originalName: "Zest and juice of lemons",
          amount: 2.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 18413,
          aisle: "Bakery/Bread",
          image: "pita-bread.jpg",
          consistency: "solid",
          name: "pita",
          nameClean: "pita",
          original: "4 pita pockets",
          originalName: "pita pockets",
          amount: 4.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 10011282,
          aisle: "Produce",
          image: "red-onion.png",
          consistency: "solid",
          name: "red onion",
          nameClean: "red onion",
          original: "1 small red onion, chopped",
          originalName: "red onion, chopped",
          amount: 1.0,
          unit: "small",
          meta: ["red", "chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "small",
              unitLong: "small",
            },
            metric: {
              amount: 1.0,
              unitShort: "small",
              unitLong: "small",
            },
          },
        },
        {
          id: 1102047,
          aisle: "Spices and Seasonings",
          image: "salt-and-pepper.jpg",
          consistency: "solid",
          name: "salt and pepper",
          nameClean: "salt and pepper",
          original: "Salt and pepper, to taste",
          originalName: "Salt and pepper, to taste",
          amount: 4.0,
          unit: "servings",
          meta: ["to taste"],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 12698,
          aisle: "Ethnic Foods;Health Foods",
          image: "tahini-paste.png",
          consistency: "solid",
          name: "tahini",
          nameClean: "tahini",
          original: "1/2 cup tahini",
          originalName: "tahini",
          amount: 0.5,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2043,
          aisle: "Spices and Seasonings",
          image: "turmeric.jpg",
          consistency: "solid",
          name: "turmeric",
          nameClean: "turmeric",
          original: "1 1/2 teaspoons turmeric",
          originalName: "turmeric",
          amount: 1.5,
          unit: "teaspoons",
          meta: [],
          measures: {
            us: {
              amount: 1.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 1.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 4513,
          aisle: null,
          image: null,
          consistency: null,
          name: "vegetable oil",
          nameClean: null,
          original: "1/4 cup vegetable oil",
          originalName: "vegetable oil",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "3 tablespoons water",
          originalName: "water",
          amount: 3.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 3.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
      ],
      id: 642540,
      title: "Falafel Burgers",
      readyInMinutes: 45,
      servings: 4,
      sourceUrl: "http://www.foodista.com/recipe/FBWMX8MY/falafel-burgers",
      image: "https://spoonacular.com/recipeImages/642540-556x370.jpg",
      imageType: "jpg",
      summary:
        'The recipe Falafel Burgers is ready <b>in approximately 45 minutes</b> and is definitely an amazing <b>vegan</b> option for lovers of American food. For <b>$1.9 per serving</b>, this recipe <b>covers 29%</b> of your daily requirements of vitamins and minerals. One serving contains <b>708 calories</b>, <b>23g of protein</b>, and <b>35g of fat</b>. This recipe is liked by 69 foodies and cooks. It works well as a main course. Head to the store and pick up tahini, chili powder, coriander, and a few other things to make it today. To use up the flour you could follow this main course with the <a href="https://spoonacular.com/recipes/apple-tart-with-caramel-sauce-47961">Apple Tart with Caramel Sauce</a> as a dessert. All things considered, we decided this recipe <b>deserves a spoonacular score of 94%</b>. This score is spectacular. Try <a href="https://spoonacular.com/recipes/falafel-burgers-308498">Falafel Burgers</a>, <a href="https://spoonacular.com/recipes/falafel-burgers-31895">Falafel Burgers</a>, and <a href="https://spoonacular.com/recipes/falafel-burgers-216987">Falafel burgers</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["dairy free", "lacto ovo vegetarian", "vegan"],
      occasions: [],
      winePairing: {
        pairedWines: [],
        pairingText: "",
        productMatches: [],
      },
      instructions:
        "<ol><li>Combine the chickpeas, onion, garlic, parsley, flour, spices, and salt, and pulse until the mixture is well combined. Form the mixture into 4 large patties.</li><li>Heat the oil in a large, nonstick skillet set over medium-high heat. Cook for about 3 minutes per side.</li><li>Make the tahini sauce: Whisk the tahini paste with the water, lemon juice and zest, salt, and freshly ground black pepper in a mixing bowl.</li><li>Serve the burgers in pita pockets or on a bun. Top them with tahini sauce, lettuce, and tomato.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Combine the chickpeas, onion, garlic, parsley, flour, spices, and salt, and pulse until the mixture is well combined. Form the mixture into 4 large patties.",
              ingredients: [
                {
                  id: 16057,
                  name: "chickpeas",
                  localizedName: "chickpeas",
                  image: "chickpeas.png",
                },
                {
                  id: 11297,
                  name: "parsley",
                  localizedName: "parsley",
                  image: "parsley.jpg",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 2035,
                  name: "spices",
                  localizedName: "spices",
                  image: "spices.png",
                },
                {
                  id: 20081,
                  name: "all purpose flour",
                  localizedName: "all purpose flour",
                  image: "flour.png",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
        {
          name: "Heat the oil in a large, nonstick skillet set over medium-high heat. Cook for about 3 minutes per side.Make the tahini sauce",
          steps: [
            {
              number: 1,
              step: "Whisk the tahini paste with the water, lemon juice and zest, salt, and freshly ground black pepper in a mixing bowl.",
              ingredients: [
                {
                  id: 1002030,
                  name: "ground black pepper",
                  localizedName: "ground black pepper",
                  image: "pepper.jpg",
                },
                {
                  id: 12698,
                  name: "tahini",
                  localizedName: "tahini",
                  image: "tahini-paste.png",
                },
                {
                  id: 9152,
                  name: "lemon juice",
                  localizedName: "lemon juice",
                  image: "lemon-juice.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 405907,
                  name: "mixing bowl",
                  localizedName: "mixing bowl",
                  image: "mixing-bowl.jpg",
                },
                {
                  id: 404661,
                  name: "whisk",
                  localizedName: "whisk",
                  image: "whisk.png",
                },
              ],
            },
            {
              number: 2,
              step: "Serve the burgers in pita pockets or on a bun. Top them with tahini sauce, lettuce, and tomato.",
              ingredients: [
                {
                  id: 11252,
                  name: "lettuce",
                  localizedName: "lettuce",
                  image: "iceberg-lettuce.jpg",
                },
                {
                  id: 12698,
                  name: "tahini",
                  localizedName: "tahini",
                  image: "tahini-paste.png",
                },
                {
                  id: 11529,
                  name: "tomato",
                  localizedName: "tomato",
                  image: "tomato.png",
                },
                {
                  id: 0,
                  name: "sauce",
                  localizedName: "sauce",
                  image: "",
                },
                {
                  id: 18413,
                  name: "pita",
                  localizedName: "pita",
                  image: "pita-bread.jpg",
                },
                {
                  id: 0,
                  name: "roll",
                  localizedName: "roll",
                  image: "dinner-yeast-rolls.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl: "https://spoonacular.com/falafel-burgers-642540",
    },
  },
  {
    id: 646512,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 10,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 12,
      spoonacularScore: 93.0,
      healthScore: 65.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 300.93,
      extendedIngredients: [
        {
          id: 43015,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "coleslaw-or-caesar-dressing.jpg",
          consistency: "liquid",
          name: "caesar dressing",
          nameClean: "caesar salad dressing",
          original: "2 tablespoons light caesar dressing",
          originalName: "light caesar dressing",
          amount: 2.0,
          unit: "tablespoons",
          meta: ["light"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "lemon juice",
          nameClean: "lemon juice",
          original: "2 tablespoons freshly squeezed lemon juice",
          originalName: "freshly squeezed lemon juice",
          amount: 2.0,
          unit: "tablespoons",
          meta: ["freshly squeezed"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 4053,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "olive oil",
          nameClean: "olive oil",
          original: "1 tablespoon Olive oil",
          originalName: "Olive oil",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 2028,
          aisle: "Spices and Seasonings",
          image: "paprika.jpg",
          consistency: "solid",
          name: "paprika",
          nameClean: "paprika",
          original: "1/4 teaspoon paprika",
          originalName: "paprika",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 1033,
          aisle: "Cheese",
          image: "parmesan.jpg",
          consistency: "solid",
          name: "parmesan cheese",
          nameClean: "parmesan",
          original: "8 tablespoons Parmesan cheese, shredded",
          originalName: "Parmesan cheese, shredded",
          amount: 8.0,
          unit: "tablespoons",
          meta: ["shredded"],
          measures: {
            us: {
              amount: 8.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 8.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 1002030,
          aisle: "Spices and Seasonings",
          image: "pepper.jpg",
          consistency: "solid",
          name: "pepper",
          nameClean: "black pepper",
          original: "add black pepper to taste",
          originalName: "add black pepper to taste",
          amount: 2.0,
          unit: "servings",
          meta: ["black", "to taste"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 2.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 10111251,
          aisle: "Produce",
          image: "romaine.jpg",
          consistency: "solid",
          name: "romaine",
          nameClean: "romaine",
          original: "1 8 oz head of Romaine",
          originalName: "Romaine",
          amount: 8.0,
          unit: "oz",
          meta: [],
          measures: {
            us: {
              amount: 8.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 226.796,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 15076,
          aisle: "Seafood",
          image: "salmon.png",
          consistency: "solid",
          name: "salmon fillet",
          nameClean: "salmon",
          original: "6 ounces Salmon fillet",
          originalName: "Salmon fillet",
          amount: 6.0,
          unit: "ounces",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 170.097,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "1/4 teaspoon salt",
          originalName: "salt",
          amount: 0.25,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.25,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 10012061,
          aisle: "Baking",
          image: "almonds-slivered.png",
          consistency: "solid",
          name: "slivered almonds",
          nameClean: "slivered almonds",
          original: "1 tablespoon slivered almonds",
          originalName: "slivered almonds",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
      ],
      id: 646512,
      title: "Salmon Caesar Salad",
      readyInMinutes: 45,
      servings: 2,
      sourceUrl:
        "http://www.foodista.com/recipe/36WZD7DS/healthy-salmon-caesar-salad-recipe",
      image: "https://spoonacular.com/recipeImages/646512-556x370.jpg",
      imageType: "jpg",
      summary:
        'Salmon Caesar Salad might be just the main course you are searching for. This gluten free, primal, fodmap friendly, and pescatarian recipe serves 2 and costs <b>$3.01 per serving</b>. One serving contains <b>393 calories</b>, <b>27g of protein</b>, and <b>29g of fat</b>. Only a few people made this recipe, and 7 would say it hit the spot. A mixture of caesar dressing, romaine, slivered almonds, and a handful of other ingredients are all it takes to make this recipe so delicious. To use up the salt you could follow this main course with the <a href="https://spoonacular.com/recipes/apple-turnovers-recipe-48175">Apple Turnovers Recipe</a> as a dessert. From preparation to the plate, this recipe takes roughly <b>45 minutes</b>. This recipe is typical of American cuisine. All things considered, we decided this recipe <b>deserves a spoonacular score of 92%</b>. This score is excellent. Try <a href="https://spoonacular.com/recipes/salmon-caesar-salad-521731">Salmon Caesar Salad</a>, <a href="https://spoonacular.com/recipes/salmon-caesar-salad-418441">Salmon Caesar Salad</a>, and <a href="https://spoonacular.com/recipes/salmon-caesar-salad-277721">Salmon Caesar Salad</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["salad"],
      diets: ["gluten free", "primal", "pescatarian"],
      occasions: [],
      winePairing: {
        pairedWines: ["chardonnay", "pinot noir", "sauvignon blanc"],
        pairingText:
          "Chardonnay, Pinot Noir, and Sauvignon Blanc are great choices for Salmon. To decide on white or red, you should consider your seasoning and sauces. Chardonnay is a great friend to buttery, creamy dishes, while sauvignon blanc can complement herb or citrus-centric dishes. A light-bodied, low-tannin red such as the pinot noir goes great with broiled or grilled salmon. The Chateau Ste. Michelle Indian Wells Chardonnay Wine with a 5 out of 5 star rating seems like a good match. It costs about 18 dollars per bottle.",
        productMatches: [
          {
            id: 428201,
            title: "Chateau Ste. Michelle Indian Wells Chardonnay Wine",
            description:
              '"Our Indian Wells Chardonnay delivers an appealing tropical fruit character typical of warm sites like the Wahluke Slope. I like this Chardonnay\'s ripe pineapple and butterscotch flavors and rich, creamy texture. Try it with Scallops, scampi or pasta with rich sauces." - Bob Bertheau',
            price: "$18.0",
            imageUrl:
              "https://spoonacular.com/productImages/428201-312x231.jpg",
            averageRating: 1.0,
            ratingCount: 2.0,
            score: 0.8571428571428572,
            link: "https://www.amazon.com/Chateau-Ste-Michelle-Indian-Chardonnay/dp/B06XJYVKF4?tag=spoonacular-20",
          },
        ],
      },
      instructions:
        "<ol><li>Directions: Heat up a skillet/frying pan and sir the Salmon in the coconut oil/olive oil (don't forget to add the salt and paprika to it) until very lightly browned on each side (i like my salmon slightly undercooked-its up to you if you want it more done). Top with freshly squeezed lemon juice and let it sit in the frying pan for about 1 minute. In a Large bowl, mix the romaine lettuce with the Caesar salad dressing and dump it out into a large plate, top off with Asiago/Parmesan cheese and you can also sprinkle the toasted almonds on now. Place the Salmon (sliced) on top. You can sprinkle it with some more fresh lemon juice:) and black pepper!</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Heat up a skillet/frying pan and sir the Salmon in the coconut oil/olive oil (don't forget to add the salt and paprika to it) until very lightly browned on each side (i like my salmon slightly undercooked-its up to you if you want it more done). Top with freshly squeezed lemon juice and let it sit in the frying pan for about 1 minute. In a Large bowl, mix the romaine lettuce with the Caesar salad dressing and dump it out into a large plate, top off with Asiago/Parmesan cheese and you can also sprinkle the toasted almonds on now.",
              ingredients: [
                {
                  id: 43015,
                  name: "caesar salad dressing",
                  localizedName: "caesar salad dressing",
                  image: "coleslaw-or-caesar-dressing.jpg",
                },
                {
                  id: 1033,
                  name: "parmesan",
                  localizedName: "parmesan",
                  image: "parmesan.jpg",
                },
                {
                  id: 10111251,
                  name: "romaine",
                  localizedName: "romaine",
                  image: "romaine",
                },
                {
                  id: 4047,
                  name: "coconut oil",
                  localizedName: "coconut oil",
                  image: "oil-coconut.jpg",
                },
                {
                  id: 9152,
                  name: "lemon juice",
                  localizedName: "lemon juice",
                  image: "lemon-juice.jpg",
                },
                {
                  id: 4053,
                  name: "olive oil",
                  localizedName: "olive oil",
                  image: "olive-oil.jpg",
                },
                {
                  id: 12061,
                  name: "almonds",
                  localizedName: "almonds",
                  image: "almonds.jpg",
                },
                {
                  id: 2028,
                  name: "paprika",
                  localizedName: "paprika",
                  image: "paprika.jpg",
                },
                {
                  id: 1001033,
                  name: "asiago cheese",
                  localizedName: "asiago cheese",
                  image: "parmesan.jpg",
                },
                {
                  id: 15076,
                  name: "salmon",
                  localizedName: "salmon",
                  image: "salmon.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: {
                number: 1,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Place the Salmon (sliced) on top. You can sprinkle it with some more fresh lemon juice:) and black pepper!",
              ingredients: [
                {
                  id: 1002030,
                  name: "black pepper",
                  localizedName: "black pepper",
                  image: "pepper.jpg",
                },
                {
                  id: 9152,
                  name: "lemon juice",
                  localizedName: "lemon juice",
                  image: "lemon-juice.jpg",
                },
                {
                  id: 15076,
                  name: "salmon",
                  localizedName: "salmon",
                  image: "salmon.png",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/salmon-caesar-salad-646512",
    },
  },
  {
    id: 1046982,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 19,
      gaps: "no",
      lowFodmap: false,
      preparationMinutes: 15,
      cookingMinutes: 25,
      aggregateLikes: 11,
      spoonacularScore: 93.0,
      healthScore: 64.0,
      creditsText: "Jen West",
      sourceName: "Pink When",
      pricePerServing: 481.76,
      extendedIngredients: [
        {
          id: 10211821,
          aisle: "Produce",
          image: "bell-pepper-orange.png",
          consistency: "solid",
          name: "bell pepper",
          nameClean: "bell pepper",
          original: "1/2 cup diced bell pepper",
          originalName: "diced bell pepper",
          amount: 0.5,
          unit: "cup",
          meta: ["diced"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "1 clove garlic diced",
          originalName: "garlic diced",
          amount: 1.0,
          unit: "clove",
          meta: ["diced"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "clove",
              unitLong: "clove",
            },
            metric: {
              amount: 1.0,
              unitShort: "clove",
              unitLong: "clove",
            },
          },
        },
        {
          id: 5662,
          aisle: "Meat",
          image: "meat-ground.jpg",
          consistency: "solid",
          name: "lean ground turkey",
          nameClean: "ground turkey",
          original: "1 1/2 pounds lean ground turkey",
          originalName: "lean ground turkey",
          amount: 1.5,
          unit: "pounds",
          meta: ["lean"],
          measures: {
            us: {
              amount: 1.5,
              unitShort: "lb",
              unitLong: "pounds",
            },
            metric: {
              amount: 680.389,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 4053,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "olive oil",
          nameClean: "olive oil",
          original: "olive oil",
          originalName: "olive oil",
          amount: 4.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "onion",
          nameClean: "onion",
          original: "1/2 cup diced onion",
          originalName: "diced onion",
          amount: 0.5,
          unit: "cup",
          meta: ["diced"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 1102047,
          aisle: "Spices and Seasonings",
          image: "salt-and-pepper.jpg",
          consistency: "solid",
          name: "salt and pepper",
          nameClean: "salt and pepper",
          original: "salt and pepper to taste",
          originalName: "salt and pepper to taste",
          amount: 4.0,
          unit: "servings",
          meta: ["to taste"],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11507,
          aisle: "Produce",
          image: "sweet-potato.png",
          consistency: "solid",
          name: "sweet potatoes",
          nameClean: "sweet potato",
          original: "4 large sweet potatoes",
          originalName: "sweet potatoes",
          amount: 4.0,
          unit: "large",
          meta: [],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "large",
              unitLong: "larges",
            },
            metric: {
              amount: 4.0,
              unitShort: "large",
              unitLong: "larges",
            },
          },
        },
        {
          id: 11887,
          aisle: "Pasta and Rice",
          image: "tomato-paste.jpg",
          consistency: "solid",
          name: "tomato paste",
          nameClean: "tomato paste",
          original: "6 ounces tomato paste",
          originalName: "tomato paste",
          amount: 6.0,
          unit: "ounces",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 170.097,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11549,
          aisle: "Canned and Jarred",
          image: "tomato-sauce-or-pasta-sauce.jpg",
          consistency: "solid",
          name: "tomato sauce",
          nameClean: "canned tomato sauce",
          original: "14 ounces tomato sauce",
          originalName: "tomato sauce",
          amount: 14.0,
          unit: "ounces",
          meta: [],
          measures: {
            us: {
              amount: 14.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 396.893,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "1 cup water",
          originalName: "water",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 1046982,
      title: "How to Make the Perfect Sweet Potato Sloppy Joes",
      readyInMinutes: 40,
      servings: 4,
      sourceUrl:
        "https://www.pinkwhen.com/how-to-make-the-perfect-sweet-potato-sloppy-joes/",
      image: "https://spoonacular.com/recipeImages/1046982-556x370.jpg",
      imageType: "jpg",
      summary:
        'How to Make the Perfect Sweet Potato Sloppy Joes might be just the <b>American</b> recipe you are searching for. One portion of this dish contains roughly <b>46g of protein</b>, <b>7g of fat</b>, and a total of <b>407 calories</b>. For <b>$3.99 per serving</b>, you get a main course that serves 4. 10 people have tried and liked this recipe. Head to the store and pick up salt and pepper, water, ground turkey, and a few other things to make it today. It is a good option if you\'re following a <b>gluten free, dairy free, paleolithic, and primal</b> diet. From preparation to the plate, this recipe takes around <b>40 minutes</b>. It is brought to you by Pink When. Overall, this recipe earns a <b>solid spoonacular score of 50%</b>. Similar recipes are <a href="https://spoonacular.com/recipes/just-perfect-sloppy-joes-82826">Just Perfect Sloppy Joes</a>, <a href="https://spoonacular.com/recipes/how-to-make-classic-sloppy-joes-471307">How to Make Classic Sloppy Joes</a>, and <a href="https://spoonacular.com/recipes/make-ahead-sloppy-joes-428874">Make-Ahead Sloppy Joes</a>.',
      cuisines: ["American"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["gluten free", "dairy free", "paleolithic", "primal"],
      occasions: [],
      winePairing: {
        pairedWines: [],
        pairingText: "",
        productMatches: [],
      },
      instructions:
        "Instructions\n\n\n\nPreheat the oven to 425 degrees. Pierce the sweet potatoes all over the skin with a fork. Rub the outside of the potatoes with olive oil and cover with foil. Bake in the oven for 1 hour until fully cooked.\n\n\nBrown the ground turkey in a skillet on medium heat. Once it's finished cooking, add the onion, bell pepper, and garlic. Mix well. Cook until the mixture is fully cooked and starts to crumble.\n\n\nStir in the garlic, water, tomato paste, and tomato sauce. Stir until mixed well. Turn heat down to low and simmer for 20 minutes, stirring occasionally.\n\n\nRemove the sweet potatoes from the foil and slice down the middle. Mash up the insides with a fork and pour the sloppy joe mix over sweet potatoes. Serve and enjoy!",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Preheat the oven to 425 degrees. Pierce the sweet potatoes all over the skin with a fork. Rub the outside of the potatoes with olive oil and cover with foil.",
              ingredients: [
                {
                  id: 11507,
                  name: "sweet potato",
                  localizedName: "sweet potato",
                  image: "sweet-potato.png",
                },
                {
                  id: 4053,
                  name: "olive oil",
                  localizedName: "olive oil",
                  image: "olive-oil.jpg",
                },
                {
                  id: 11352,
                  name: "potato",
                  localizedName: "potato",
                  image: "potatoes-yukon-gold.png",
                },
                {
                  id: 1012034,
                  name: "dry seasoning rub",
                  localizedName: "dry seasoning rub",
                  image: "seasoning.png",
                },
              ],
              equipment: [
                {
                  id: 404765,
                  name: "aluminum foil",
                  localizedName: "aluminum foil",
                  image: "aluminum-foil.png",
                },
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Bake in the oven for 1 hour until fully cooked.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: {
                number: 60,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Brown the ground turkey in a skillet on medium heat. Once it's finished cooking, add the onion, bell pepper, and garlic.",
              ingredients: [
                {
                  id: 5662,
                  name: "ground turkey",
                  localizedName: "ground turkey",
                  image: "meat-ground.jpg",
                },
                {
                  id: 10211821,
                  name: "bell pepper",
                  localizedName: "bell pepper",
                  image: "bell-pepper-orange.png",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
            },
            {
              number: 4,
              step: "Mix well. Cook until the mixture is fully cooked and starts to crumble.",
              ingredients: [],
              equipment: [],
            },
            {
              number: 5,
              step: "Stir in the garlic, water, tomato paste, and tomato sauce. Stir until mixed well. Turn heat down to low and simmer for 20 minutes, stirring occasionally.",
              ingredients: [
                {
                  id: 11887,
                  name: "tomato paste",
                  localizedName: "tomato paste",
                  image: "tomato-paste.jpg",
                },
                {
                  id: 11549,
                  name: "tomato sauce",
                  localizedName: "tomato sauce",
                  image: "tomato-sauce-or-pasta-sauce.jpg",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [],
              length: {
                number: 20,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "Remove the sweet potatoes from the foil and slice down the middle. Mash up the insides with a fork and pour the sloppy joe mix over sweet potatoes.",
              ingredients: [
                {
                  id: 11507,
                  name: "sweet potato",
                  localizedName: "sweet potato",
                  image: "sweet-potato.png",
                },
              ],
              equipment: [
                {
                  id: 404765,
                  name: "aluminum foil",
                  localizedName: "aluminum foil",
                  image: "aluminum-foil.png",
                },
              ],
            },
            {
              number: 7,
              step: "Serve and enjoy!",
              ingredients: [],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/how-to-make-the-perfect-sweet-potato-sloppy-joes-1046982",
    },
  },
  {
    id: 633837,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: true,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 17,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 89.0,
      healthScore: 51.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 166.59,
      extendedIngredients: [
        {
          id: 4073,
          aisle: "Milk, Eggs, Other Dairy",
          image: "butter-sliced.jpg",
          consistency: "solid",
          name: "margarine",
          nameClean: "margarine",
          original: "1 -T margarine or butter, melted",
          originalName: "margarine or butter, melted",
          amount: 1.0,
          unit: "T",
          meta: ["melted"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 2025,
          aisle: "Spices and Seasonings",
          image: "ground-nutmeg.jpg",
          consistency: "solid",
          name: "nutmeg",
          nameClean: "nutmeg",
          original: "dash nutmeg",
          originalName: "nutmeg",
          amount: 1.0,
          unit: "dash",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "dash",
              unitLong: "dash",
            },
            metric: {
              amount: 1.0,
              unitShort: "dash",
              unitLong: "dash",
            },
          },
        },
        {
          id: 1042047,
          aisle: "Spices and Seasonings",
          image: "garlic-salt.jpg",
          consistency: "solid",
          name: "seasoned salt",
          nameClean: "seasoned salt",
          original: "1/4 -t seasoned salt",
          originalName: "t seasoned salt",
          amount: 0.25,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 0.25,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 11507,
          aisle: "Produce",
          image: "sweet-potato.png",
          consistency: "solid",
          name: "sweet potatoes",
          nameClean: "sweet potato",
          original: "4 smalls sweet potatoes (about 1 lb)",
          originalName: "smalls sweet potatoes (about",
          amount: 1.0,
          unit: "lb",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "lb",
              unitLong: "pound",
            },
            metric: {
              amount: 453.592,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
      ],
      id: 633837,
      title: "Baked Sweet Potato Fries",
      readyInMinutes: 45,
      servings: 1,
      sourceUrl:
        "http://www.foodista.com/recipe/HDVQBNZX/baked-sweet-potato-fries",
      image: "https://spoonacular.com/recipeImages/633837-556x370.jpg",
      imageType: "jpg",
      summary:
        'Need a <b>gluten free, dairy free, and whole 30 side dish</b>? Baked Sweet Potato Fries could be an outstanding recipe to try. For <b>$1.67 per serving</b>, this recipe <b>covers 23%</b> of your daily requirements of vitamins and minerals. This recipe makes 1 servings with <b>496 calories</b>, <b>7g of protein</b>, and <b>12g of fat</b> each. A mixture of margarine, dash nutmeg, t seasoned salt, and a handful of other ingredients are all it takes to make this recipe so flavorful. This recipe from Foodista has 1 fans. From preparation to the plate, this recipe takes around <b>45 minutes</b>. This recipe is typical of American cuisine. All things considered, we decided this recipe <b>deserves a spoonacular score of 89%</b>. This score is tremendous. Try <a href="https://spoonacular.com/recipes/baked-sweet-potato-fries-473667">Baked Sweet Potato Fries</a>, <a href="https://spoonacular.com/recipes/baked-sweet-potato-fries-577316">Baked Sweet Potato Fries</a>, and <a href="https://spoonacular.com/recipes/baked-sweet-potato-fries-121468">Baked Sweet Potato Fries</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["side dish"],
      diets: ["gluten free", "dairy free"],
      occasions: [],
      winePairing: {
        pairedWines: [],
        pairingText: "",
        productMatches: [],
      },
      instructions:
        "<ol><li>Spray a 15 x 10 x 1 inch baking pan with nonstick coating. Scrub potatoes; cut lengthwise into quarters, then cut each quarter into 2 wedges. Arrange potatoes in a single layer in pan.</li><li>Combine margarine or butter, salt, and nutmeg. Brush onto potatoes. Bake in a 450 oven 20 minutes or until brown and tender.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Spray a 15 x 10 x 1 inch baking pan with nonstick coating. Scrub potatoes; cut lengthwise into quarters, then cut each quarter into 2 wedges. Arrange potatoes in a single layer in pan.",
              ingredients: [
                {
                  id: 11352,
                  name: "potato",
                  localizedName: "potato",
                  image: "potatoes-yukon-gold.png",
                },
              ],
              equipment: [
                {
                  id: 404646,
                  name: "baking pan",
                  localizedName: "baking pan",
                  image: "roasting-pan.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Combine margarine or butter, salt, and nutmeg.",
              ingredients: [
                {
                  id: 4073,
                  name: "margarine",
                  localizedName: "margarine",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 1001,
                  name: "butter",
                  localizedName: "butter",
                  image: "butter-sliced.jpg",
                },
                {
                  id: 2025,
                  name: "nutmeg",
                  localizedName: "nutmeg",
                  image: "ground-nutmeg.jpg",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 3,
              step: "Brush onto potatoes.",
              ingredients: [
                {
                  id: 11352,
                  name: "potato",
                  localizedName: "potato",
                  image: "potatoes-yukon-gold.png",
                },
              ],
              equipment: [],
            },
            {
              number: 4,
              step: "Bake in a 450 oven 20 minutes or until brown and tender.",
              ingredients: [],
              equipment: [
                {
                  id: 404784,
                  name: "oven",
                  localizedName: "oven",
                  image: "oven.jpg",
                },
              ],
              length: {
                number: 20,
                unit: "minutes",
              },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/baked-sweet-potato-fries-633837",
    },
  },
  {
    id: 639392,
    value: {
      vegetarian: true,
      vegan: false,
      glutenFree: false,
      dairyFree: false,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 19,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 88.0,
      healthScore: 71.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 220.66,
      extendedIngredients: [
        {
          id: 9037,
          aisle: "Produce",
          image: "avocado.jpg",
          consistency: "solid",
          name: "avocado",
          nameClean: "avocado",
          original: "Sliced avocado",
          originalName: "Sliced avocado",
          amount: 6.0,
          unit: "servings",
          meta: ["sliced"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 2004,
          aisle: "Spices and Seasonings",
          image: "bay-leaves.jpg",
          consistency: "solid",
          name: "bay leaf",
          nameClean: "bay leaves",
          original: "1 bay leaf",
          originalName: "bay leaf",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 10019071,
          aisle: "Baking",
          image: "chocolate-chips.jpg",
          consistency: "solid",
          name: "bittersweet chocolate chips",
          nameClean: "dark chocolate chips",
          original: "1/2 cup bittersweet chocolate chips (I like Ghirardelli)",
          originalName: "bittersweet chocolate chips (I like Ghirardelli)",
          amount: 0.5,
          unit: "cup",
          meta: ["(I like Ghirardelli)"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 118.294,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 16015,
          aisle: "Pasta and Rice;Canned and Jarred",
          image: "black-beans.jpg",
          consistency: "solid",
          name: "black beans",
          nameClean: "black beans",
          original: "1 cup black beans",
          originalName: "black beans",
          amount: 1.0,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 16015,
          aisle: "Pasta and Rice;Canned and Jarred",
          image: "black-beans.jpg",
          consistency: "solid",
          name: "black beans",
          nameClean: "black beans",
          original: "Black Beans",
          originalName: "Black Beans",
          amount: 6.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 10016034,
          aisle: "Canned and Jarred",
          image: "kidney-beans.jpg",
          consistency: "solid",
          name: "canned red kidney beans",
          nameClean: "canned red kidney beans",
          original: "1 (15 oz.) can red kidney beans, drained and rinsed",
          originalName: "red kidney beans, drained and rinsed",
          amount: 15.0,
          unit: "oz",
          meta: ["red", "drained and rinsed", "canned"],
          measures: {
            us: {
              amount: 15.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 425.243,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 10011693,
          aisle: "Canned and Jarred",
          image: "tomatoes-canned.png",
          consistency: "solid",
          name: "canned tomatoes",
          nameClean: "canned tomatoes",
          original: "1 (28 oz.) can crushed tomatoes",
          originalName: "crushed tomatoes",
          amount: 28.0,
          unit: "oz",
          meta: ["crushed", "canned"],
          measures: {
            us: {
              amount: 28.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 793.787,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11819,
          aisle: "Produce",
          image: "red-chili.jpg",
          consistency: "solid",
          name: "chili",
          nameClean: "chili pepper",
          original: "Chili",
          originalName: "Chili",
          amount: 6.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 2009,
          aisle: "Spices and Seasonings",
          image: "chili-powder.jpg",
          consistency: "solid",
          name: "chili powder",
          nameClean: "chili powder",
          original: "2 teaspoons chili powder (mine is a bit on the hot side)",
          originalName: "chili powder (mine is a bit on the hot side)",
          amount: 2.0,
          unit: "teaspoons",
          meta: ["hot", "(mine is a bit on the side)"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 10218364,
          aisle: "Bakery/Bread;Pasta and Rice;Ethnic Foods",
          image: "flour-tortilla.jpg",
          consistency: "solid",
          name: "flour tortillas",
          nameClean: "flour tortilla",
          original: "Toasted corn or flour tortillas for scooping",
          originalName: "Toasted corn or flour tortillas for scooping",
          amount: 6.0,
          unit: "servings",
          meta: ["toasted", "for scooping"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11165,
          aisle: "Produce;Spices and Seasonings",
          image: "cilantro.png",
          consistency: "solid",
          name: "fresh cilantro",
          nameClean: "cilantro",
          original: "Chopped fresh cilantro",
          originalName: "Chopped fresh cilantro",
          amount: 6.0,
          unit: "servings",
          meta: ["fresh", "chopped"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic cloves",
          nameClean: "garlic",
          original: "2 garlic cloves, chopped",
          originalName: "garlic cloves, chopped",
          amount: 2.0,
          unit: "",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 2.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 1002013,
          aisle: "Spices and Seasonings",
          image: "ground-coriander.jpg",
          consistency: "solid",
          name: "ground coriander",
          nameClean: "ground coriander",
          original: "1 teaspoon ground coriander",
          originalName: "ground coriander",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 1002014,
          aisle: "Spices and Seasonings",
          image: "ground-cumin.jpg",
          consistency: "solid",
          name: "ground cumin",
          nameClean: "cumin",
          original: "2 teaspoons ground cumin",
          originalName: "ground cumin",
          amount: 2.0,
          unit: "teaspoons",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 1002030,
          aisle: "Spices and Seasonings",
          image: "pepper.jpg",
          consistency: "solid",
          name: "ground pepper",
          nameClean: "black pepper",
          original: "1/2 teaspoon ground black pepper",
          originalName: "ground black pepper",
          amount: 0.5,
          unit: "teaspoon",
          meta: ["black"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 1001025,
          aisle: "Cheese",
          image: "shredded-cheese-white.jpg",
          consistency: "solid",
          name: "monterey jack cheese",
          nameClean: "monterey jack cheese",
          original: "Shredded Monterey Jack cheese",
          originalName: "Shredded Monterey Jack cheese",
          amount: 6.0,
          unit: "servings",
          meta: ["shredded"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 4053,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "olive oil",
          nameClean: "olive oil",
          original: "1 tablespoon olive oil",
          originalName: "olive oil",
          amount: 1.0,
          unit: "tablespoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
            metric: {
              amount: 1.0,
              unitShort: "Tbsp",
              unitLong: "Tbsp",
            },
          },
        },
        {
          id: 2027,
          aisle: "Produce;Spices and Seasonings",
          image: "oregano.jpg",
          consistency: "solid",
          name: "oregano",
          nameClean: "oregano",
          original: "1 teaspoon dried oregano",
          originalName: "dried oregano",
          amount: 1.0,
          unit: "teaspoon",
          meta: ["dried"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 11821,
          aisle: "Produce",
          image: "red-pepper.jpg",
          consistency: "solid",
          name: "red bell pepper",
          nameClean: "red pepper",
          original: "1 red bell pepper, cored, seeded and chopped",
          originalName: "red bell pepper, cored, seeded and chopped",
          amount: 1.0,
          unit: "",
          meta: ["red", "cored", "seeded", "chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 1012047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "sea salt",
          nameClean: "coarse sea salt",
          original: "1 teaspoon sea salt",
          originalName: "sea salt",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 11677,
          aisle: "Produce",
          image: "shallots.jpg",
          consistency: "solid",
          name: "shallot",
          nameClean: "shallot",
          original: "1 large shallot, chopped",
          originalName: "shallot, chopped",
          amount: 1.0,
          unit: "large",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
            metric: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
          },
        },
        {
          id: 1056,
          aisle: "Milk, Eggs, Other Dairy",
          image: "sour-cream.jpg",
          consistency: "solid",
          name: "sour cream",
          nameClean: "sour cream",
          original: "Sour cream or plain yogurt",
          originalName: "Sour cream or plain yogurt",
          amount: 6.0,
          unit: "servings",
          meta: ["plain", "sour"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 11954,
          aisle: "Produce",
          image: "tomatillos.jpg",
          consistency: "solid",
          name: "tomatillos",
          nameClean: "tomatillos",
          original: "4 tomatillos, husked, cleaned and chopped",
          originalName: "tomatillos, husked, cleaned and chopped",
          amount: 4.0,
          unit: "",
          meta: ["husked", "cleaned", "chopped"],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 4.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 14412,
          aisle: "Beverages",
          image: "water.png",
          consistency: "liquid",
          name: "water",
          nameClean: "water",
          original: "6 cups water",
          originalName: "water",
          amount: 6.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 1.42,
              unitShort: "l",
              unitLong: "liters",
            },
          },
        },
        {
          id: null,
          aisle: "?",
          image: null,
          consistency: null,
          name: "garnishes",
          nameClean: null,
          original: "Garnishes",
          originalName: "Garnishes",
          amount: 6.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
      ],
      id: 639392,
      title: "Chunky Two-Bean Chili",
      readyInMinutes: 45,
      servings: 6,
      sourceUrl:
        "http://www.foodista.com/recipe/3RLLDMHY/chunky-two-bean-chili",
      image: "https://spoonacular.com/recipeImages/639392-556x370.jpg",
      imageType: "jpg",
      summary:
        'Chunky Two-Bean Chili might be just the main course you are searching for. For <b>$2.19 per serving</b>, this recipe <b>covers 39%</b> of your daily requirements of vitamins and minerals. Watching your figure? This vegetarian recipe has <b>658 calories</b>, <b>23g of protein</b>, and <b>28g of fat</b> per serving. This recipe is typical of American cuisine. This recipe is liked by 1 foodies and cooks. From preparation to the plate, this recipe takes about <b>45 minutes</b>. It will be a hit at your <b>The Super Bowl</b> event. Head to the store and pick up monterey jack cheese, garnishes, garlic cloves, and a few other things to make it today. To use up the olive oil you could follow this main course with the <a href="https://spoonacular.com/recipes/sauteed-banana-granola-and-yogurt-parfait-624619">Sauteed Banana, Granolan and Yogurt Parfait</a> as a dessert. All things considered, we decided this recipe <b>deserves a spoonacular score of 89%</b>. This score is outstanding. Try <a href="https://spoonacular.com/recipes/chunky-no-bean-chili-927681">Chunky No Bean Chili</a>, <a href="https://spoonacular.com/recipes/chunky-no-bean-chili-769071">Chunky No Bean Chili</a>, and <a href="https://spoonacular.com/recipes/chunky-two-bean-and-beef-chili-238882">Chunky Two-Bean and Beef Chili</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["lacto ovo vegetarian"],
      occasions: ["super bowl"],
      winePairing: {
        pairedWines: ["cava", "grenache", "shiraz"],
        pairingText:
          "Chili works really well with Cava, Grenache, and Shiraz. These juicy reds don't have too much tannin (important for spicy foods), but a sparkling wine like cava can tame the heat even better. The Marques de Caceres Cava with a 4.7 out of 5 star rating seems like a good match. It costs about 16 dollars per bottle.",
        productMatches: [
          {
            id: 473598,
            title: "Marques de Caceres Cava",
            description:
              "Pale straw color revived by fine bubbles. Bouquet of citrus fruits with notes of brioche. Charming and round in the mouth with a refreshing, balanced structure. Lively finish that highlights its fine bubbles.A refreshing aperitif, this Cava marries well with fish and seafood, pasta, rice, spicy dishes, Asian cuisine, and all types of desserts.",
            price: "$15.99",
            imageUrl:
              "https://spoonacular.com/productImages/473598-312x231.jpg",
            averageRating: 0.9400000000000001,
            ratingCount: 19.0,
            score: 0.9227586206896552,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Fmarques-de-caceres-cava%2F520811",
          },
        ],
      },
      instructions:
        "<ol><li>Rinse and drain black beans and discard any rocks or funky-looking (discolored, wrinkly) beans.</li><li>In heavy soup pot, combine black beans, 6 cups of water, salt and bay leaf.</li><li>Bring to a boil.</li><li>Reduce heat and simmer, partially covered, until beans are tender, about 1 hours.</li><li>Keep an eye on the water, and add more if needed, 1 cup at a time. Beans should have some liquid remaining, but they should not be overly soupy.</li><li>When beans are almost done, prepare the vegetables.</li><li>In large saucepan, heat the olive oil and saut the shallot, garlic, red pepper, and tomatillos until tender, 10-15 minutes.</li><li>When beans are completely tender, remove the bay leaf, and add the sauted vegetables and any remaining oil, the salt, pepper, spices, kidney beans, crushed tomatoes, and chocolate chips.</li><li>Bring chili to a boil.</li><li>Reduce heat and simmer, uncovered, until chili thickens and flavors meld, about 30 minutes.</li><li>Stir occasionally.</li><li>Remove pot from heat and let chili cool for about 20 minutes before pureeing two cups in blender. If you try to puree hot liquid in a blender, the people who move into your house after you will inherit the splatter, and they will curse you.</li><li>Return pureed chili to pot and mix through.</li><li>Taste, and add salt and pepper if needed.</li><li>Heat through until warm, about 5 minutes.</li><li>Ladle into bowls and heap on whichever garnishes speak to you.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Rinse and drain black beans and discard any rocks or funky-looking (discolored, wrinkly) beans.In heavy soup pot, combine black beans, 6 cups of water, salt and bay leaf.Bring to a boil.Reduce heat and simmer, partially covered, until beans are tender, about 1 hours.Keep an eye on the water, and add more if needed, 1 cup at a time. Beans should have some liquid remaining, but they should not be overly soupy.When beans are almost done, prepare the vegetables.In large saucepan, heat the olive oil and saut the shallot, garlic, red pepper, and tomatillos until tender, 10-15 minutes.When beans are completely tender, remove the bay leaf, and add the sauted vegetables and any remaining oil, the salt, pepper, spices, kidney beans, crushed tomatoes, and chocolate chips.Bring chili to a boil.Reduce heat and simmer, uncovered, until chili thickens and flavors meld, about 30 minutes.Stir occasionally.",
              ingredients: [
                {
                  id: 11693,
                  name: "crushed tomatoes",
                  localizedName: "crushed tomatoes",
                  image: "tomatoes-canned.png",
                },
                {
                  id: 99278,
                  name: "chocolate chips",
                  localizedName: "chocolate chips",
                  image: "chocolate-chips.jpg",
                },
                {
                  id: 16033,
                  name: "kidney beans",
                  localizedName: "kidney beans",
                  image: "kidney-beans.jpg",
                },
                {
                  id: 16015,
                  name: "black beans",
                  localizedName: "black beans",
                  image: "black-beans.jpg",
                },
                {
                  id: 11821,
                  name: "red pepper",
                  localizedName: "red pepper",
                  image: "red-pepper.jpg",
                },
                {
                  id: 11954,
                  name: "tomatillos",
                  localizedName: "tomatillos",
                  image: "tomatillos.jpg",
                },
                {
                  id: 11583,
                  name: "vegetable",
                  localizedName: "vegetable",
                  image: "mixed-vegetables.png",
                },
                {
                  id: 4053,
                  name: "olive oil",
                  localizedName: "olive oil",
                  image: "olive-oil.jpg",
                },
                {
                  id: 2004,
                  name: "bay leaves",
                  localizedName: "bay leaves",
                  image: "bay-leaves.jpg",
                },
                {
                  id: 11677,
                  name: "shallot",
                  localizedName: "shallot",
                  image: "shallots.jpg",
                },
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
                {
                  id: 1002030,
                  name: "pepper",
                  localizedName: "pepper",
                  image: "pepper.jpg",
                },
                {
                  id: 2035,
                  name: "spices",
                  localizedName: "spices",
                  image: "spices.png",
                },
                {
                  id: 0,
                  name: "beans",
                  localizedName: "beans",
                  image: "kidney-beans.jpg",
                },
                {
                  id: 11819,
                  name: "chili pepper",
                  localizedName: "chili pepper",
                  image: "red-chili.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
                {
                  id: 0,
                  name: "soup",
                  localizedName: "soup",
                  image: "",
                },
                {
                  id: 4582,
                  name: "cooking oil",
                  localizedName: "cooking oil",
                  image: "vegetable-oil.jpg",
                },
              ],
              equipment: [
                {
                  id: 404669,
                  name: "sauce pan",
                  localizedName: "sauce pan",
                  image: "sauce-pan.jpg",
                },
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 105,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Remove pot from heat and let chili cool for about 20 minutes before pureeing two cups in blender. If you try to puree hot liquid in a blender, the people who move into your house after you will inherit the splatter, and they will curse you.Return pureed chili to pot and mix through.Taste, and add salt and pepper if needed.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
                {
                  id: 11819,
                  name: "chili pepper",
                  localizedName: "chili pepper",
                  image: "red-chili.jpg",
                },
              ],
              equipment: [
                {
                  id: 404726,
                  name: "blender",
                  localizedName: "blender",
                  image: "blender.png",
                },
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 20,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Heat through until warm, about 5 minutes.Ladle into bowls and heap on whichever garnishes speak to you.",
              ingredients: [],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404630,
                  name: "ladle",
                  localizedName: "ladle",
                  image: "ladle.jpg",
                },
              ],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/chunky-two-bean-chili-639392",
    },
  },
  {
    id: 637897,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: false,
      dairyFree: true,
      veryHealthy: true,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 16,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 1,
      spoonacularScore: 88.0,
      healthScore: 88.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 256.34,
      extendedIngredients: [
        {
          id: 11457,
          aisle: "Produce",
          image: "spinach.jpg",
          consistency: "solid",
          name: "baby spinach",
          nameClean: "baby spinach",
          original: "3 cups of baby spinach, cut into thin strips",
          originalName: "baby spinach, cut into thin strips",
          amount: 3.0,
          unit: "cups",
          meta: ["cut into thin strips"],
          measures: {
            us: {
              amount: 3.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 709.764,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2004,
          aisle: "Spices and Seasonings",
          image: "bay-leaves.jpg",
          consistency: "solid",
          name: "bay leaf",
          nameClean: "bay leaves",
          original: "1 bay leaf",
          originalName: "bay leaf",
          amount: 1.0,
          unit: "",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
            metric: {
              amount: 1.0,
              unitShort: "",
              unitLong: "",
            },
          },
        },
        {
          id: 10211821,
          aisle: "Produce",
          image: "bell-pepper-orange.png",
          consistency: "solid",
          name: "bell pepper",
          nameClean: "bell pepper",
          original: "freshly ground black pepper",
          originalName: "freshly ground black pepper",
          amount: 6.0,
          unit: "servings",
          meta: ["black", "freshly ground"],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 10011693,
          aisle: "Canned and Jarred",
          image: "tomatoes-canned.png",
          consistency: "solid",
          name: "canned tomatoes",
          nameClean: "canned tomatoes",
          original: "1 can (28- ounce) of crushed tomatoes",
          originalName: "can of crushed tomatoes",
          amount: 28.0,
          unit: "ounce",
          meta: ["crushed", "canned"],
          measures: {
            us: {
              amount: 28.0,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 793.787,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 6172,
          aisle: "Canned and Jarred",
          image: "chicken-broth.png",
          consistency: "liquid",
          name: "chicken stock",
          nameClean: "chicken stock",
          original: "4 cups of Chicken Stock",
          originalName: "Chicken Stock",
          amount: 4.0,
          unit: "cups",
          meta: [],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 946.352,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2009,
          aisle: "Spices and Seasonings",
          image: "chili-powder.jpg",
          consistency: "solid",
          name: "chili powder",
          nameClean: "chili powder",
          original: "2 teaspoons of chili powder",
          originalName: "chili powder",
          amount: 2.0,
          unit: "teaspoons",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 2.0,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 16056,
          aisle: "Pasta and Rice;Canned and Jarred;Ethnic Foods",
          image: "chickpeas.png",
          consistency: "solid",
          name: "dried chickpeas",
          nameClean: "dried chickpeas",
          original:
            "2 cups of chickpeas (preferably, dried beans that have been soaked/cooked)",
          originalName:
            "chickpeas (preferably, dried beans that have been soaked/cooked)",
          amount: 2.0,
          unit: "cups",
          meta: ["dried", "(preferably, beans that have been soaked/cooked)"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 473.176,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 11215,
          aisle: "Produce",
          image: "garlic.png",
          consistency: "solid",
          name: "garlic",
          nameClean: "garlic",
          original: "2 tablespoons garlic, chopped",
          originalName: "garlic, chopped",
          amount: 2.0,
          unit: "tablespoons",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 5332,
          aisle: "Meat",
          image: "meat-ground.jpg",
          consistency: "solid",
          name: "ground chicken",
          nameClean: "ground chicken",
          original: "1 pound of ground chicken",
          originalName: "ground chicken",
          amount: 1.0,
          unit: "pound",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "lb",
              unitLong: "pound",
            },
            metric: {
              amount: 453.592,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 1012010,
          aisle: "Spices and Seasonings",
          image: "cinnamon.jpg",
          consistency: "solid",
          name: "ground cinnamon",
          nameClean: "ground cinnamon",
          original: "1 teaspoon ground cinnamon",
          originalName: "ground cinnamon",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 1002014,
          aisle: "Spices and Seasonings",
          image: "ground-cumin.jpg",
          consistency: "solid",
          name: "ground cumin",
          nameClean: "cumin",
          original: "1 teaspoon ground cumin",
          originalName: "ground cumin",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 1082047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "kosher salt",
          nameClean: "kosher salt",
          original: "kosher salt",
          originalName: "kosher salt",
          amount: 6.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 6.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 4053,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "olive-oil.jpg",
          consistency: "liquid",
          name: "olive oil",
          nameClean: "olive oil",
          original: "2 tablespoons of olive oil",
          originalName: "olive oil",
          amount: 2.0,
          unit: "tablespoons",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbsps",
              unitLong: "Tbsps",
            },
          },
        },
        {
          id: 11282,
          aisle: "Produce",
          image: "brown-onion.png",
          consistency: "solid",
          name: "onion",
          nameClean: "onion",
          original: "1 large onion, chopped",
          originalName: "onion, chopped",
          amount: 1.0,
          unit: "large",
          meta: ["chopped"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
            metric: {
              amount: 1.0,
              unitShort: "large",
              unitLong: "large",
            },
          },
        },
        {
          id: 10920420,
          aisle: "Pasta and Rice",
          image: "orzo.jpg",
          consistency: "solid",
          name: "orzo pasta",
          nameClean: "orzo",
          original: "1 cup of whole-wheat orzo pasta",
          originalName: "whole-wheat orzo pasta",
          amount: 1.0,
          unit: "cup",
          meta: ["whole-wheat"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "cup",
              unitLong: "cup",
            },
            metric: {
              amount: 236.588,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 2028,
          aisle: "Spices and Seasonings",
          image: "paprika.jpg",
          consistency: "solid",
          name: "paprika",
          nameClean: "paprika",
          original: "1 teaspoon of paprika",
          originalName: "paprika",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 19335,
          aisle: "Baking",
          image: "sugar-in-bowl.png",
          consistency: "solid",
          name: "sugar",
          nameClean: "sugar",
          original: "1 teaspoon of sugar",
          originalName: "sugar",
          amount: 1.0,
          unit: "teaspoon",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
      ],
      id: 637897,
      title: "Chicken and Chickpea Chili",
      readyInMinutes: 60,
      servings: 6,
      sourceUrl:
        "http://www.foodista.com/recipe/PD75LLZQ/chicken-and-chickpea-chili",
      image: "https://spoonacular.com/recipeImages/637897-556x370.jpg",
      imageType: "jpg",
      summary:
        'The recipe Chicken and Chickpea Chili is ready <b>in around 1 hour</b> and is definitely a tremendous <b>dairy free</b> option for lovers of American food. For <b>$2.18 per serving</b>, this recipe <b>covers 43%</b> of your daily requirements of vitamins and minerals. One serving contains <b>607 calories</b>, <b>37g of protein</b>, and <b>18g of fat</b>. It can be enjoyed any time, but it is especially good for <b>The Super Bowl</b>. Not a lot of people made this recipe, and 1 would say it hit the spot. Head to the store and pick up garlic, bay leaf, olive oil, and a few other things to make it today. To use up the kosher salt you could follow this main course with the <a href="https://spoonacular.com/recipes/low-fat-crumbs-cake-kosher-dairy-130933">Low Fat Crumbs Cake (Kosher-Dairy)</a> as a dessert. It works well as a reasonably priced main course. All things considered, we decided this recipe <b>deserves a spoonacular score of 85%</b>. This score is super. Try <a href="https://spoonacular.com/recipes/slow-cooker-salsa-verde-chicken-chickpea-chili-720884">Slow Cooker Salsa Verde Chicken Chickpea Chili</a>, <a href="https://spoonacular.com/recipes/chickpea-chili-31899">Chickpea Chili</a>, and <a href="https://spoonacular.com/recipes/lamb-chickpea-chili-for-two-696854">Lamb & Chickpea Chili for Two</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["dairy free"],
      occasions: ["super bowl"],
      winePairing: {
        pairedWines: [],
        pairingText: "",
        productMatches: [],
      },
      instructions:
        "<ol><li>Heat olive oil in a Dutch oven or soup pot.</li><li>Flame should be medium to low.  Add onions and cook for about 5 minutes, or until soft and translucent.</li><li>Add the garlic.  Cook for about 1 minutes.</li><li>Add the spices and move around pot for about 1-2 minutes.</li><li>Add the ground meat, 1 teaspoon of salt and  a teaspoon of pepper.  Cook meat until completely cooked thru.</li><li>Then add the chickpeas.</li><li>Add the tomatoes, sugar and chicken stock.</li><li>Bring the soup to a bowl.</li><li>Then reduce heat and allow to simmer for about 40-45 minutes.  Taste.</li><li>Add more salt and pepper if necessary.</li><li>Add the orzo pasta.  Cook for 6 minutes.</li><li>Turn off heat and add the spinach.</li><li>Serve with crusty bread or crackers</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Heat olive oil in a Dutch oven or soup pot.Flame should be medium to low.",
              ingredients: [
                {
                  id: 4053,
                  name: "olive oil",
                  localizedName: "olive oil",
                  image: "olive-oil.jpg",
                },
                {
                  id: 0,
                  name: "soup",
                  localizedName: "soup",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404667,
                  name: "dutch oven",
                  localizedName: "dutch oven",
                  image: "dutch-oven.jpg",
                },
              ],
            },
            {
              number: 2,
              step: "Add onions and cook for about 5 minutes, or until soft and translucent.",
              ingredients: [
                {
                  id: 11282,
                  name: "onion",
                  localizedName: "onion",
                  image: "brown-onion.png",
                },
              ],
              equipment: [],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 3,
              step: "Add the garlic.  Cook for about 1 minutes.",
              ingredients: [
                {
                  id: 11215,
                  name: "garlic",
                  localizedName: "garlic",
                  image: "garlic.png",
                },
              ],
              equipment: [],
              length: {
                number: 1,
                unit: "minutes",
              },
            },
            {
              number: 4,
              step: "Add the spices and move around pot for about 1-2 minutes.",
              ingredients: [
                {
                  id: 2035,
                  name: "spices",
                  localizedName: "spices",
                  image: "spices.png",
                },
              ],
              equipment: [
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 2,
                unit: "minutes",
              },
            },
            {
              number: 5,
              step: "Add the ground meat, 1 teaspoon of salt and  a teaspoon of pepper.  Cook meat until completely cooked thru.Then add the chickpeas.",
              ingredients: [
                {
                  id: 10023572,
                  name: "ground beef",
                  localizedName: "ground beef",
                  image: "fresh-ground-beef.jpg",
                },
                {
                  id: 16057,
                  name: "chickpeas",
                  localizedName: "chickpeas",
                  image: "chickpeas.png",
                },
                {
                  id: 1002030,
                  name: "pepper",
                  localizedName: "pepper",
                  image: "pepper.jpg",
                },
                {
                  id: 1065062,
                  name: "meat",
                  localizedName: "meat",
                  image: "whole-chicken.jpg",
                },
                {
                  id: 2047,
                  name: "salt",
                  localizedName: "salt",
                  image: "salt.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 6,
              step: "Add the tomatoes, sugar and chicken stock.Bring the soup to a bowl.Then reduce heat and allow to simmer for about 40-45 minutes.  Taste.",
              ingredients: [
                {
                  id: 6172,
                  name: "chicken stock",
                  localizedName: "chicken stock",
                  image: "chicken-broth.png",
                },
                {
                  id: 11529,
                  name: "tomato",
                  localizedName: "tomato",
                  image: "tomato.png",
                },
                {
                  id: 19335,
                  name: "sugar",
                  localizedName: "sugar",
                  image: "sugar-in-bowl.png",
                },
                {
                  id: 0,
                  name: "soup",
                  localizedName: "soup",
                  image: "",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: {
                number: 45,
                unit: "minutes",
              },
            },
            {
              number: 7,
              step: "Add more salt and pepper if necessary.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
              ],
              equipment: [],
            },
            {
              number: 8,
              step: "Add the orzo pasta.  Cook for 6 minutes.Turn off heat and add the spinach.",
              ingredients: [
                {
                  id: 10920420,
                  name: "orzo",
                  localizedName: "orzo",
                  image: "orzo.jpg",
                },
                {
                  id: 10011457,
                  name: "spinach",
                  localizedName: "spinach",
                  image: "spinach.jpg",
                },
              ],
              equipment: [],
              length: {
                number: 6,
                unit: "minutes",
              },
            },
            {
              number: 9,
              step: "Serve with crusty bread or crackers",
              ingredients: [
                {
                  id: 10018029,
                  name: "crusty bread",
                  localizedName: "crusty bread",
                  image: "crusty-bread.jpg",
                },
                {
                  id: 18621,
                  name: "crackers",
                  localizedName: "crackers",
                  image: "crackers.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/chicken-and-chickpea-chili-637897",
    },
  },
  {
    id: 638552,
    value: {
      vegetarian: false,
      vegan: false,
      glutenFree: true,
      dairyFree: false,
      veryHealthy: false,
      cheap: false,
      veryPopular: false,
      sustainable: false,
      weightWatcherSmartPoints: 9,
      gaps: "no",
      lowFodmap: false,
      aggregateLikes: 10,
      spoonacularScore: 87.0,
      healthScore: 40.0,
      creditsText: "Foodista.com – The Cooking Encyclopedia Everyone Can Edit",
      license: "CC BY 3.0",
      sourceName: "Foodista",
      pricePerServing: 300.37,
      extendedIngredients: [
        {
          id: 10011693,
          aisle: "Canned and Jarred",
          image: "tomatoes-canned.png",
          consistency: "solid",
          name: "canned tomatoes",
          nameClean: "canned tomatoes",
          original:
            "800 gr.s of Italian little pomodori tomatoes a can, with their juice ( This means 2 cans ). I used the brand Ci",
          originalName:
            "s of Italian little pomodori tomatoes a can, with their juice ( This means 2 cans ). I used the brand Ci",
          amount: 800.0,
          unit: "gr",
          meta: [
            "italian",
            "with their juice ( this means 2 cans ). i used the brand ci",
          ],
          measures: {
            us: {
              amount: 1.764,
              unitShort: "lb",
              unitLong: "pounds",
            },
            metric: {
              amount: 800.0,
              unitShort: "gr",
              unitLong: "grs",
            },
          },
        },
        {
          id: 11135,
          aisle: "Produce",
          image: "cauliflower.jpg",
          consistency: "solid",
          name: "cauliflower",
          nameClean: "cauliflower",
          original: "1 medium head cauliflower, broken into small florets",
          originalName: "cauliflower, broken into small florets",
          amount: 1.0,
          unit: "medium head",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "medium head",
              unitLong: "medium head",
            },
            metric: {
              amount: 1.0,
              unitShort: "medium head",
              unitLong: "medium head",
            },
          },
        },
        {
          id: 1017,
          aisle: "Cheese",
          image: "cream-cheese.jpg",
          consistency: "solid",
          name: "cream cheese",
          nameClean: "cream cheese",
          original: "2 Tbs cream cheese",
          originalName: "cream cheese",
          amount: 2.0,
          unit: "Tbs",
          meta: [],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
          },
        },
        {
          id: 1002014,
          aisle: "Spices and Seasonings",
          image: "ground-cumin.jpg",
          consistency: "solid",
          name: "cumin",
          nameClean: "cumin",
          original: "1 tsp cumin",
          originalName: "cumin",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 2041,
          aisle: "Produce;Spices and Seasonings",
          image: "tarragon.jpg",
          consistency: "solid",
          name: "dried tarragon",
          nameClean: "tarragon",
          original: "½ tsp dried tarragon",
          originalName: "dried tarragon",
          amount: 0.5,
          unit: "tsp",
          meta: ["dried"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 11297,
          aisle: "Produce;Spices and Seasonings",
          image: "parsley.jpg",
          consistency: "solid",
          name: "fresh parsley",
          nameClean: "parsley",
          original: "½ tsp fresh parsley, chopped",
          originalName: "fresh parsley, chopped",
          amount: 0.5,
          unit: "tsp",
          meta: ["fresh", "chopped"],
          measures: {
            us: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
            metric: {
              amount: 0.5,
              unitShort: "tsps",
              unitLong: "teaspoons",
            },
          },
        },
        {
          id: 31015,
          aisle: "Produce",
          image: "chili-peppers-green.jpg",
          consistency: "solid",
          name: "green chilies",
          nameClean: "green chili pepper",
          original: "130g green chilies, drained and diced",
          originalName: "green chilies, drained and diced",
          amount: 130.0,
          unit: "g",
          meta: ["diced", "green", "drained"],
          measures: {
            us: {
              amount: 4.586,
              unitShort: "oz",
              unitLong: "ounces",
            },
            metric: {
              amount: 130.0,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 9152,
          aisle: "Produce",
          image: "lemon-juice.jpg",
          consistency: "liquid",
          name: "lemon juice",
          nameClean: "lemon juice",
          original: "2 Tbs fresh lemon juice",
          originalName: "fresh lemon juice",
          amount: 2.0,
          unit: "Tbs",
          meta: ["fresh"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
          },
        },
        {
          id: 4025,
          aisle: "Condiments",
          image: "mayonnaise.png",
          consistency: "liquid",
          name: "mayonnaise",
          nameClean: "mayonnaise",
          original: "¼ cup mayonnaise",
          originalName: "mayonnaise",
          amount: 0.25,
          unit: "cup",
          meta: [],
          measures: {
            us: {
              amount: 0.25,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 59.147,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
        {
          id: 4582,
          aisle: "Oil, Vinegar, Salad Dressing",
          image: "vegetable-oil.jpg",
          consistency: "liquid",
          name: "oil",
          nameClean: "cooking oil",
          original: "1 tsp oil",
          originalName: "oil",
          amount: 1.0,
          unit: "tsp",
          meta: [],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
            metric: {
              amount: 1.0,
              unitShort: "tsp",
              unitLong: "teaspoon",
            },
          },
        },
        {
          id: 10010062,
          aisle: "Meat",
          image: "pork-chops.jpg",
          consistency: "solid",
          name: "pork chops",
          nameClean: "pork chops",
          original: "4 boneless pork chops (about 1 pound)",
          originalName: "boneless pork chops (about",
          amount: 1.0,
          unit: "pound",
          meta: ["boneless"],
          measures: {
            us: {
              amount: 1.0,
              unitShort: "lb",
              unitLong: "pound",
            },
            metric: {
              amount: 453.592,
              unitShort: "g",
              unitLong: "grams",
            },
          },
        },
        {
          id: 11821,
          aisle: "Produce",
          image: "red-pepper.jpg",
          consistency: "solid",
          name: "red bell pepper",
          nameClean: "red pepper",
          original: "2 Tbs green or red bell pepper, chopped",
          originalName: "green or red bell pepper, chopped",
          amount: 2.0,
          unit: "Tbs",
          meta: ["green", "red", "chopped"],
          measures: {
            us: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
            metric: {
              amount: 2.0,
              unitShort: "Tbs",
              unitLong: "Tbs",
            },
          },
        },
        {
          id: 2047,
          aisle: "Spices and Seasonings",
          image: "salt.jpg",
          consistency: "solid",
          name: "salt",
          nameClean: "table salt",
          original: "salt to taste",
          originalName: "salt to taste",
          amount: 4.0,
          unit: "servings",
          meta: ["to taste"],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 1102047,
          aisle: "Spices and Seasonings",
          image: "salt-and-pepper.jpg",
          consistency: "solid",
          name: "salt and pepper",
          nameClean: "salt and pepper",
          original: "Salt and pepper",
          originalName: "Salt and pepper",
          amount: 4.0,
          unit: "servings",
          meta: [],
          measures: {
            us: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
            metric: {
              amount: 4.0,
              unitShort: "servings",
              unitLong: "servings",
            },
          },
        },
        {
          id: 1040,
          aisle: "Cheese",
          image: "Swiss-cheese.jpg",
          consistency: "solid",
          name: "swiss cheese",
          nameClean: "swiss cheese",
          original: "1/3 cup Cheddar or Swiss cheese, grated",
          originalName: "Cheddar or Swiss cheese, grated",
          amount: 0.3333333333333333,
          unit: "cup",
          meta: ["grated"],
          measures: {
            us: {
              amount: 0.333,
              unitShort: "cups",
              unitLong: "cups",
            },
            metric: {
              amount: 78.863,
              unitShort: "ml",
              unitLong: "milliliters",
            },
          },
        },
      ],
      id: 638552,
      title: "Chili chops with cauliflower salad",
      readyInMinutes: 45,
      servings: 4,
      sourceUrl:
        "http://www.foodista.com/recipe/B2NXFCCF/chili-chops-with-cauliflower-salad",
      image: "https://spoonacular.com/recipeImages/638552-556x370.jpg",
      imageType: "jpg",
      summary:
        'Chili chops with cauliflower salad might be just the main course you are searching for. This gluten free recipe serves 4 and costs <b>$3.0 per serving</b>. One serving contains <b>454 calories</b>, <b>34g of protein</b>, and <b>26g of fat</b>. 10 people have made this recipe and would make it again. It is perfect for <b>The Super Bowl</b>. Head to the store and pick up canned tomatoes, salt, tarragon, and a few other things to make it today. To use up the salt and pepper you could follow this main course with the <a href="https://spoonacular.com/recipes/dr-pepper-cake-with-flour-cooked-frosting-539165">Dr. Pepper Cake with Flour Cooked Frosting</a> as a dessert. This recipe is typical of American cuisine. From preparation to the plate, this recipe takes around <b>45 minutes</b>. All things considered, we decided this recipe <b>deserves a spoonacular score of 88%</b>. This score is great. Try <a href="https://spoonacular.com/recipes/lamb-chops-with-cauliflower-and-raisins-15646">Lamb Chops with Cauliflower and Raisins</a>, <a href="https://spoonacular.com/recipes/chili-chops-399509">Chili Chops</a>, and <a href="https://spoonacular.com/recipes/chili-chops-417937">Chili Chops</a> for similar recipes.',
      cuisines: ["American"],
      dishTypes: ["lunch", "main course", "main dish", "dinner"],
      diets: ["gluten free"],
      occasions: ["super bowl"],
      winePairing: {
        pairedWines: ["cava", "grenache", "shiraz"],
        pairingText:
          "Cava, Grenache, and Shiraz are great choices for Chili. These juicy reds don't have too much tannin (important for spicy foods), but a sparkling wine like cava can tame the heat even better. One wine you could try is Papet del Mas Cava Brut. It has 4.5 out of 5 stars and a bottle costs about 15 dollars.",
        productMatches: [
          {
            id: 2043598,
            title: "Papet del Mas Cava Brut",
            description:
              "Pleasant fruit aromas and a bright, clear color. The taste sensation in the mouth is very pleasant, light and well balanced, fresh and very cheerful feeling, good persistence, with fruit and flower notes. The aftertaste invites you to continue savoring the wine.",
            price: "$14.99",
            imageUrl:
              "https://spoonacular.com/productImages/2043598-312x231.jpg",
            averageRating: 0.9,
            ratingCount: 10.0,
            score: 0.867741935483871,
            link: "https://click.linksynergy.com/deeplink?id=*QCiIS6t4gA&mid=2025&murl=https%3A%2F%2Fwww.wine.com%2Fproduct%2Fpapet-del-mas-cava-brut%2F152712",
          },
        ],
      },
      instructions:
        "<ol><li>Season chops with salt and pepper and brown them in a nonstick skillet over medium-high heat for about 2 minutes per side.</li><li>Combine salsa, chilies and cumin in a bowl. Pour mixture over chops. Reduce heat to low, cover skillet and simmer chops 5 minutes or until cooked through.</li><li>Mix cheeses in a bowl. Divide cheese mixture over chops, cover and cook 1 minute, just until cheese melts.</li><li>Cauliflower salad:</li><li>Cook cauliflower florets in a large pot of salted, boiling water until tender-crisp, 5 to 10 minutes. Drain and rinse under cold water.</li><li>Or cook in MWC for 15 minutes.</li><li>In a large bowl, combine mayonnaise, lemon juice and tarragon. Add cauliflower, jalapeno, salt and pepper.</li><li>Mix well until cauliflower florets are evenly coated with dressing. Chill at least 30 minutes for flavors to blend. (Can be made ahead. Store in an airtight container and refrigerate up to 24 hours.)</li><li>Sprinkle with parsley just before serving.</li></ol>",
      analyzedInstructions: [
        {
          name: "",
          steps: [
            {
              number: 1,
              step: "Season chops with salt and pepper and brown them in a nonstick skillet over medium-high heat for about 2 minutes per side.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
              ],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: {
                number: 2,
                unit: "minutes",
              },
            },
            {
              number: 2,
              step: "Combine salsa, chilies and cumin in a bowl.",
              ingredients: [
                {
                  id: 11819,
                  name: "chili pepper",
                  localizedName: "chili pepper",
                  image: "red-chili.jpg",
                },
                {
                  id: 1002014,
                  name: "cumin",
                  localizedName: "cumin",
                  image: "ground-cumin.jpg",
                },
                {
                  id: 6164,
                  name: "salsa",
                  localizedName: "salsa",
                  image: "salsa.png",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
            },
            {
              number: 3,
              step: "Pour mixture over chops. Reduce heat to low, cover skillet and simmer chops 5 minutes or until cooked through.",
              ingredients: [],
              equipment: [
                {
                  id: 404645,
                  name: "frying pan",
                  localizedName: "frying pan",
                  image: "pan.png",
                },
              ],
              length: {
                number: 5,
                unit: "minutes",
              },
            },
            {
              number: 4,
              step: "Mix cheeses in a bowl. Divide cheese mixture over chops, cover and cook 1 minute, just until cheese melts.Cauliflower salad:Cook cauliflower florets in a large pot of salted, boiling water until tender-crisp, 5 to 10 minutes.",
              ingredients: [
                {
                  id: 10011135,
                  name: "cauliflower florets",
                  localizedName: "cauliflower florets",
                  image: "cauliflower.jpg",
                },
                {
                  id: 11135,
                  name: "cauliflower",
                  localizedName: "cauliflower",
                  image: "cauliflower.jpg",
                },
                {
                  id: 1041009,
                  name: "cheese",
                  localizedName: "cheese",
                  image: "cheddar-cheese.png",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
                {
                  id: 404752,
                  name: "pot",
                  localizedName: "pot",
                  image: "stock-pot.jpg",
                },
              ],
              length: {
                number: 6,
                unit: "minutes",
              },
            },
            {
              number: 5,
              step: "Drain and rinse under cold water.Or cook in MWC for 15 minutes.In a large bowl, combine mayonnaise, lemon juice and tarragon.",
              ingredients: [
                {
                  id: 9152,
                  name: "lemon juice",
                  localizedName: "lemon juice",
                  image: "lemon-juice.jpg",
                },
                {
                  id: 4025,
                  name: "mayonnaise",
                  localizedName: "mayonnaise",
                  image: "mayonnaise.png",
                },
                {
                  id: 2041,
                  name: "tarragon",
                  localizedName: "tarragon",
                  image: "tarragon.jpg",
                },
                {
                  id: 14412,
                  name: "water",
                  localizedName: "water",
                  image: "water.png",
                },
              ],
              equipment: [
                {
                  id: 404783,
                  name: "bowl",
                  localizedName: "bowl",
                  image: "bowl.jpg",
                },
              ],
              length: {
                number: 15,
                unit: "minutes",
              },
            },
            {
              number: 6,
              step: "Add cauliflower, jalapeno, salt and pepper.",
              ingredients: [
                {
                  id: 1102047,
                  name: "salt and pepper",
                  localizedName: "salt and pepper",
                  image: "salt-and-pepper.jpg",
                },
                {
                  id: 11135,
                  name: "cauliflower",
                  localizedName: "cauliflower",
                  image: "cauliflower.jpg",
                },
                {
                  id: 11979,
                  name: "jalapeno pepper",
                  localizedName: "jalapeno pepper",
                  image: "jalapeno-pepper.png",
                },
              ],
              equipment: [],
            },
            {
              number: 7,
              step: "Mix well until cauliflower florets are evenly coated with dressing. Chill at least 30 minutes for flavors to blend. (Can be made ahead. Store in an airtight container and refrigerate up to 24 hours.)",
              ingredients: [
                {
                  id: 10011135,
                  name: "cauliflower florets",
                  localizedName: "cauliflower florets",
                  image: "cauliflower.jpg",
                },
              ],
              equipment: [],
              length: {
                number: 1470,
                unit: "minutes",
              },
            },
            {
              number: 8,
              step: "Sprinkle with parsley just before serving.",
              ingredients: [
                {
                  id: 11297,
                  name: "parsley",
                  localizedName: "parsley",
                  image: "parsley.jpg",
                },
              ],
              equipment: [],
            },
          ],
        },
      ],
      originalId: null,
      spoonacularSourceUrl:
        "https://spoonacular.com/chili-chops-with-cauliflower-salad-638552",
    },
  },
];
